export enum PastTimeEnum {
	Today = 'today',
	Yesterday = 'yesterday',
	CurrentWeek = 'currentWeek',
	LastWeek = 'last week',
	CurrentMonth = 'currentMonth',
	LastMonth = 'last month',
}

export enum StatusCampaignEnum {
	Draft = 'DRAFT',
	WaitingApproval = 'APPROVAL',
	Rejected = 'REJECTED',
	Scheduled = 'SCHEDULED',
	Stopped = 'STOPPED',
	Deleted = 'DELETED',
	Completed = 'COMPLETED',
	Failed = 'FAILED',
	Paused = 'PAUSED',
	Processing = 'PROCESS',
}

export enum ProductCategoryEnum {
	SingleProduct = 'product',
}
